import React from 'react';

function ToolbarTip(_ref) {
  var tip = _ref.tip;
  if (!tip) return false;
  return React.createElement("div", {
    className: "font-size-small line-height-large shade-30 flexbox flexbox-align-center font-weight-medium ellipsis"
  }, React.createElement("div", {
    className: "margin-right-small"
  }, tip));
}

export default React.memo(ToolbarTip);